import { useNavigate } from "react-router-dom";
import { Eye, LogOut } from "lucide-react";
import { useMe, useStopImpersonation } from "@/hooks/useAuth";

/**
 * Sticky banner shown whenever an admin is impersonating ("logged in as") a
 * user. Makes the impersonation obvious and offers one-click exit back to the
 * admin's own session.
 */
export function ImpersonationBanner() {
  const me = useMe();
  const stop = useStopImpersonation();
  const nav = useNavigate();
  if (!me.data?.impersonating) return null;

  async function exit() {
    try {
      await stop.mutateAsync();
    } finally {
      nav("/admin/dashboard", { replace: true });
      // hard reload so every cached view re-fetches as the admin
      setTimeout(() => window.location.assign("/admin/dashboard"), 50);
    }
  }

  return (
    <div className="sticky top-0 z-[60] flex items-center justify-center gap-3 bg-amber-500 px-4 py-2 text-[13px] font-medium text-black shadow-md">
      <Eye className="h-4 w-4" />
      <span>
        Viewing as <strong>{me.data.fullName}</strong> ({me.data.role}) — impersonated by {me.data.impersonatorName}
      </span>
      <button
        onClick={exit}
        disabled={stop.isPending}
        className="ml-2 inline-flex items-center gap-1 rounded-md bg-black/85 px-2.5 py-1 text-[12px] font-semibold text-white hover:bg-black disabled:opacity-60"
      >
        <LogOut className="h-3.5 w-3.5" /> Stop & return to admin
      </button>
    </div>
  );
}
